// Thin wrapper over the gtag.js snippet in public/index.html. gtag may be
// missing (ad blockers, script failed to load), so every call is a no-op then.
const send = (...args) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch (err) {
    console.warn("[analytics] gtag call failed:", err);
  }
};

// index.html configures gtag with send_page_view: false, so this is the only
// source of page_view hits — one per route change in the SPA.
export const trackPageView = (path) => {
  send("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  send("event", name, params);
};
